// extracted by mini-css-extract-plugin
module.exports = {"back":"Header_back__1KTWl","box":"Header_box__7TsXm","image":"Header_image__u0GNs","logo":"Header_logo__2GrIv","wrapper":"Header_wrapper__5xrjS"};